import { Injectable } from '@angular/core';
import { responseObj } from '../../nest-model/nest-model';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class ResourceBookingNestApi {

  private service: string = '';
  private model: string = 'sf6s/resourcebooking';

  constructor(
    private nestApi: NestApiProvider
  ) {
    
  }

  startEndBooking(formData) {
    const method: string = "POST";
    const func: string = "startEndBooking";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method,this. model, func, params, urlParams, this.service);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
    
  }

  
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/resource-booking.api.ts